import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoggingMessageService } from 'src/app/core/services/logging-message.service';
import { PendoService } from 'src/app/core/services/pendo.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit, OnDestroy {
  public hospid: number;
  private $navigationSubscription: Subscription;


  constructor(private router: Router,
    private route: ActivatedRoute,
    private pendoService: PendoService,
    private authService: AuthService,
    private logger: LoggingMessageService,
    private storageService: StorageService) { 

      this.$navigationSubscription = this.router.events
      .subscribe((e: any) => {
        // If it is a NavigationEnd event display the page
        if (e instanceof NavigationEnd) {
          this.handleNavigationEvent();
        }
      },
      );
    }

  ngOnInit(): void {
  }


  private handleNavigationEvent() {
    this.hospid = 0;
    this.updateHospitalId();

    if (environment.EnablePendo) {
      this.pendoService.updatePendo(window, this.authService.SelectedSubscription.toString(), this.authService.AvailableSubscriptionsString);
    }

    this.logger.debug('app-user-management.component', 'User Management - handleNavigation', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `Hospid:${this.hospid}`, '');
  }

  private updateHospitalId() {
    const hospid = this.route.snapshot.queryParams.hospid;
    if (hospid) {
      this.hospid = Number(hospid);
    }
  }

  private Unsubscribe() {
    if (this.$navigationSubscription) {
      this.$navigationSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }

}
